import { ArrowLeft } from "lucide-react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import type { LegalBlock, LegalDocument, LegalInline } from "@aventuria/client-core/legal";
import { Logo } from "./Logo";

export function LegalText({ content }: { content: LegalInline[] }) {
  return (
    <>
      {content.map((part, index) => {
        if (part.href) return <a key={index} href={part.href} target={part.href.startsWith("mailto:") ? undefined : "_blank"} rel="noreferrer">{part.text}</a>;
        if (part.bold) return <strong key={index}>{part.text}</strong>;
        return <Fragment key={index}>{part.text}</Fragment>;
      })}
    </>
  );
}

function Block({ block }: { block: LegalBlock }) {
  if (block.kind === "p") return <p><LegalText content={block.content} /></p>;
  if (block.kind === "list") return <ul>{block.items.map((item, index) => <li key={index}><LegalText content={item} /></li>)}</ul>;
  return (
    <div className="legal-table-wrap">
      <table className="legal-table">
        <thead><tr>{block.head.map((cell) => <th key={cell} scope="col">{cell}</th>)}</tr></thead>
        <tbody>{block.rows.map((row) => <tr key={row[0]}>{row.map((cell, index) => <td key={index}>{cell}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}

/** A public legal page (Aviso de Privacidad, Términos y condiciones) from @aventuria/client-core/legal. */
export function LegalDocumentPage({ eyebrow, document }: { eyebrow: string; document: LegalDocument }) {
  return (
    <div className="legal-page">
      <header className="legal-head">
        <Link to="/inicio" className="legal-brand" aria-label="Ir a Inicio"><Logo height={26} /></Link>
        <Link to="/inicio" className="link-button"><ArrowLeft size={15} aria-hidden="true" /> Volver a Aventuria</Link>
      </header>
      <main className="legal-body">
        <span className="page-eyebrow">{eyebrow}</span>
        <h1>{document.title}</h1>
        <p className="legal-meta">{document.dateLine}</p>
        {document.intro.map((block, index) => <Block key={index} block={block} />)}
        {document.sections.map((section) => (
          <section key={section.id} id={section.id}>
            <h2>{section.title}</h2>
            {section.blocks.map((block, index) => <Block key={index} block={block} />)}
          </section>
        ))}
      </main>
    </div>
  );
}
